import { useBetbook } from "~/store/betbook";
import { IEvent } from "~/types/sports/event";
import { IMarket } from "~/types/sports/market";
import { IOutcome } from "~/types/sports/outcome";
import { IPrice } from "~/types/sports/price";
import { IScore } from "~/types/sports/score";

const BetbookSignalRCallback = (listener: string, data: IEvent | IMarket | IOutcome | IPrice | IScore) => {
	const store = useBetbook();

	switch (listener) {
		case "event":
			const ev = data as IEvent;
			if (store.events.get(data.eventId)) {
				if (ev.isFinished) {
					store.events.delete(ev.eventId);
				} else {
					store.setEvent(data as IEvent);
				}
			}
			break;
		case "market":
			if ("marketId" in data) {
				store.setMarket(data as IMarket);
			}
			break;
		case "outcome":
			if ("outcomeId" in data) {
				store.setOutcome(data as IOutcome);
			}
			break;
		case "price":
			if ("outcomeId" in data) {
				store.setPrice(data as IPrice);
			}
			break;
		case "score":
			if ("eventId" in data) {
				store.setScore(data as IScore);
			}
			break;
	}
};

export default BetbookSignalRCallback;
